import { render } from "./DocumentsWindow.vue?vue&type=template&id=2278ff6e&scoped=true"
import script from "./DocumentsWindow.vue?vue&type=script&lang=js"
export * from "./DocumentsWindow.vue?vue&type=script&lang=js"

import "./DocumentsWindow.vue?vue&type=style&index=0&id=2278ff6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2278ff6e"]])

export default __exports__